import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { getAuthInfo } from '@/shared/utils';

const { VITE_BASE_API_URL, VITE_OCP_APIM_SUBSCRIPTION_KEY } = import.meta.env;
const BASE_API_URL = VITE_BASE_API_URL as string;
const OCP_APIM_SUBSCRIPTION_KEY = VITE_OCP_APIM_SUBSCRIPTION_KEY as string;

export const httpClient = axios.create({
	baseURL: BASE_API_URL,
	headers: {
		'Content-Type': 'application/json',
		'Ocp-Apim-Subscription-Key': OCP_APIM_SUBSCRIPTION_KEY,
	},
});

httpClient.interceptors.request.use(
	(config: InternalAxiosRequestConfig) => {
		const { accessToken, isAuthenticated } = getAuthInfo();

		if (isAuthenticated) {
			// eslint-disable-next-line no-param-reassign
			config.headers.Authorization = `${accessToken?.tokenType} ${accessToken?.accessToken}`;
		}
		return config;
	},
	(error: AxiosError) => Promise.reject(error)
);
